import { useFetchBuildingsQuery, useFetchBuildingQuery } from 'store/apis';
import { selectCurrentUserInfo } from 'store/slices';
import { useAppSelector } from 'store/store.hook';
import { getBuildingImageUrl, getBuildingLocation } from 'utils';

type Floor = {
  building_id: number;
  floor: string;
  id: number;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
};

export type Building = {
  id: number | null;
  address: string;
  city: string;
  state: string;
  zip: string;
  floors: Floor[];
  floorsCount: number;
  thumbnailUrl: string;
  location: string;
  logoUrl: string;
  primary_brand_color: string;
  secondary_brand_color: string;
};

const getBuildingDetails = ({ building = {} } = {} as any) => {
  const { floors = [], logo = null } = building;
  const floorsCount = floors.length;
  const thumbnailUrl = getBuildingImageUrl(building as any, false);
  const location = getBuildingLocation(building);
  const logoUrl = logo ? logo.url || '' : '';

  return { ...building, floorsCount, thumbnailUrl, logoUrl, location } as Building;
};

export const useBuildings = () => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { data: buildings = [], ...rest } = useFetchBuildingsQuery({ orgSlug });

  const data = buildings.map((building: any) => getBuildingDetails({ building })) as Building[];

  return { data, ...rest };
};

type UseBuildingProps = {
  buildingId: number;
};

export const useBuilding = ({ buildingId: id }: UseBuildingProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { data: building = {}, ...rest } = useFetchBuildingQuery({ orgSlug, id });

  const data = getBuildingDetails({ building });

  return { data, ...rest };
};
